(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vivi-before-after"] && !Shopify.designMode) return;
  try {
    
  class ViviBeforeAfter extends HTMLElement {
    connectedCallback() {
      this.frame = this.querySelector('.vivi-ba__frame');
      this.handle = this.querySelector('.vivi-ba__handle');
      if (!this.frame || !this.handle) return;

      this.dragging = false;
      this.onDown = this.onDown.bind(this);
      this.onMove = this.onMove.bind(this);
      this.onUp = this.onUp.bind(this);
      this.onKey = this.onKey.bind(this);

      this.frame.addEventListener('pointerdown', this.onDown);
      this.handle.addEventListener('keydown', this.onKey);
    }

    disconnectedCallback() {
      window.removeEventListener('pointermove', this.onMove);
      window.removeEventListener('pointerup', this.onUp);
    }

    setPos(pct) {
      const clamped = Math.max(2, Math.min(98, pct));
      this.frame.style.setProperty('--pos', clamped + '%');
      this.handle.setAttribute('aria-valuenow', Math.round(clamped));
    }

    posFromEvent(event) {
      const rect = this.frame.getBoundingClientRect();
      return ((event.clientX - rect.left) / rect.width) * 100;
    }

    onDown(event) {
      this.dragging = true;
      this.setPos(this.posFromEvent(event));
      window.addEventListener('pointermove', this.onMove);
      window.addEventListener('pointerup', this.onUp);
    }

    onMove(event) {
      if (!this.dragging) return;
      this.setPos(this.posFromEvent(event));
    }

    onUp() {
      this.dragging = false;
      window.removeEventListener('pointermove', this.onMove);
      window.removeEventListener('pointerup', this.onUp);
    }

    onKey(event) {
      const current = parseFloat(this.handle.getAttribute('aria-valuenow')) || 50;
      if (event.key === 'ArrowLeft') {
        this.setPos(current - 4);
        event.preventDefault();
      } else if (event.key === 'ArrowRight') {
        this.setPos(current + 4);
        event.preventDefault();
      }
    }
  }

  if (!customElements.get('vivi-ba')) {
    customElements.define('vivi-ba', ViviBeforeAfter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vivi-review-carousel"] && !Shopify.designMode) return;
  try {
    
  class ViviCarousel extends HTMLElement {
    connectedCallback() {
      const nav = this.closest('.vivi-revcar')?.querySelectorAll('.vivi-revcar__arrow');
      if (!nav) return;
      nav.forEach((btn) => {
        btn.addEventListener('click', () => {
          const card = this.querySelector('.vivi-revcar__card');
          const step = card ? card.getBoundingClientRect().width + 16 : 320;
          this.scrollBy({ left: btn.dataset.dir === 'next' ? step : -step, behavior: 'smooth' });
        });
      });
    }
  }
  if (!customElements.get('vivi-carousel')) customElements.define('vivi-carousel', ViviCarousel);

  } catch(e) { console.error(e); }
})();
})();
